import script from "./ConfirmPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmPayment.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmPayment.vue?vue&type=style&index=0&id=4d764dfd&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d764dfd"]])

export default __exports__